// extracted by mini-css-extract-plugin
module.exports = {"header":"_1D_FW","home":"_21Orm","logo":"_2D8D2"};